const testimonials = [
  {
    name: "Michelle L.",
    location: "Johns Creek, GA",
    rating: 5,
    text: "Our family's cruise to the Caribbean was in 8 days and my husband's passport was expired. Fast Passport Center walked us through the expedited renewal process step by step. We shipped from Johns Creek on Monday and had the passport by Thursday. Absolutely amazing service.",
    service: "Passport Renewal",
  },
  {
    name: "David R.",
    location: "Alpharetta, GA",
    rating: 5,
    text: "Business trip to Tokyo got moved up to 6 days out. I called in a panic from my office near Johns Creek. Started online that afternoon, shipped from Alpharetta overnight, and had my emergency passport in 3 days. The dedicated agent kept me updated the entire time.",
    service: "Emergency Passport",
  },
  {
    name: "Jennifer K.",
    location: "Duluth, GA",
    rating: 5,
    text: "We booked a trip to Mexico for spring break and realized my daughter's passport was about to expire. Fast Passport Center made the child passport process so easy. They told us exactly which clerk to visit near Johns Creek and had everything handled with time to spare.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function JohnsCreekTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North Metro Atlanta Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Johns Creek, Alpharetta, Duluth, and north metro Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}